import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { Area, BusinessCardType, CardName, PiCardSubType, PiCardType, paymentOptions, BASKET_STATUS, FT_PI_BB_NON_GUARANTEED_REMINDER } from '@whitbread-eos/api';
import { validateArrivalDate } from '../validators';
export function displayMethodType(method, variant) {
  var type = method.type,
    name = method.name,
    card = method.card,
    subType = method.subType;
  switch (true) {
    case type === PiCardType.NEW_PIBA && name === CardName.PIBA_UK:
      return 'cc.NEW_PIBA_UK';
    case type === PiCardType.NEW_PIBA && name === CardName.PIBA_EU:
      return 'cc.NEW_PIBA_EURO';
    case type === PiCardType.NEW_PIBA && subType === PiCardSubType.PIBA_UK:
      return 'cc.NEW_PIBA';
    case type === PiCardType.NEW_PIBA && subType === PiCardSubType.PIBA_EU:
      return 'cc.NEW_PIBA_EURO';
    case type === PiCardType.ACCOUNT_COMPANY:
      return 'cc.ACCOUNT_TO_COMPANY';
    case type === PiCardType.RESERVE_WITHOUT_CARD:
      return 'paymentOptions.RESERVE_WITHOUT_CARD';
    case type === PiCardType.AMEND_SAVED_CARD:
      return name;
    case type === PiCardType.SAVED_CARD:
      if (variant === Area.PI) {
        return card === null || card === void 0 ? void 0 : card.cardName;
      }
      return (card === null || card === void 0 ? void 0 : card.cardType) === BusinessCardType.BUSINESS_PERSONAL_STORED_CARD ? 'booking.payment.storedcard.personal' : 'booking.payment.storedcard.central';
    case type === PiCardType.PAYPAL_PAYMENT:
      return "booking.payment.paypal";
    default:
      return "cc.".concat(type);
  }
}
export function displayPaymentHelpText(method) {
  var type = method.type,
    card = method.card;
  switch (type) {
    case PiCardType.NEW_CARD:
    case PiCardType.NEW_PIBA:
      return 'terms.infoNewCard';
    case PiCardType.SAVED_CARD:
      return (card === null || card === void 0 ? void 0 : card.cardType) === BusinessCardType.BUSINESS_CENTRALLY_STORED_CARD ? 'terms.infoSavedPibaCard' : 'cc.cvvRequired.info';
    case PiCardType.APGP:
      return "terms.infoAPGP";
    case PiCardType.PAYPAL_PAYMENT:
      return "terms.infoPayPal";
    default:
      return "cc.cvvRequired.info";
  }
}
export function isApplePayConfigured() {
  var _ApplePaySession;
  return window !== undefined && ((_ApplePaySession = window.ApplePaySession) === null || _ApplePaySession === void 0 ? void 0 : _ApplePaySession.canMakePayments());
}
export function isGooglePayConfigured() {
  return _isGooglePayConfigured.apply(this, arguments);
}
function _isGooglePayConfigured() {
  _isGooglePayConfigured = _asyncToGenerator(function* () {
    if (typeof window === 'undefined' || !('PaymentRequest' in window)) {
      return false;
    }
    try {
      var request = new PaymentRequest([{
        supportedMethods: 'https://google.com/pay',
        data: {
          apiVersion: 2,
          apiVersionMinor: 0,
          allowedPaymentMethods: [{
            type: 'CARD',
            parameters: {
              allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
              allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA']
            }
          }]
        }
      }], {
        total: {
          label: 'Total',
          amount: {
            currency: 'GBP',
            value: '0'
          }
        }
      });
      return yield request.canMakePayment();
    } catch (_unused) {
      return false;
    }
  });
  return _isGooglePayConfigured.apply(this, arguments);
}
export function getDonationForBooking(packages, donationPackages) {
  var _donationPackages$fin;
  var defaultDonation = {
    unitPrice: 0,
    code: ''
  };
  if (!packages || !donationPackages) {
    return defaultDonation;
  }
  return (_donationPackages$fin = donationPackages.find(pckg => (pckg === null || pckg === void 0 ? void 0 : pckg.code) === (packages === null || packages === void 0 ? void 0 : packages.id))) !== null && _donationPackages$fin !== void 0 ? _donationPackages$fin : defaultDonation;
}
export function getTotalCost(ratePlanCode, totalCost, currency, packages, donationPackages, selectedDonation, variant) {
  var defaultTotalCost = {
    name: ratePlanCode,
    totalCost: {
      amount: totalCost,
      currency: currency
    }
  };
  if (variant === Area.PI) {
    var bookingDonation = getDonationForBooking(packages, donationPackages);
    if (packages && (packages === null || packages === void 0 ? void 0 : packages.id) !== '' && (packages === null || packages === void 0 ? void 0 : packages.id) === (selectedDonation === null || selectedDonation === void 0 ? void 0 : selectedDonation.code)) {
      return defaultTotalCost;
    } else {
      var _bookingDonation$unit, _selectedDonation$uni;
      return {
        name: ratePlanCode,
        totalCost: {
          amount: String(+totalCost - ((_bookingDonation$unit = bookingDonation === null || bookingDonation === void 0 ? void 0 : bookingDonation.unitPrice) !== null && _bookingDonation$unit !== void 0 ? _bookingDonation$unit : 0) + ((_selectedDonation$uni = selectedDonation === null || selectedDonation === void 0 ? void 0 : selectedDonation.unitPrice) !== null && _selectedDonation$uni !== void 0 ? _selectedDonation$uni : 0)),
          currency: currency
        }
      };
    }
  }
  return defaultTotalCost;
}
export function sortImagesByOrder(imageList) {
  var sortOrder = ['MC', 'VS', 'PP', 'AP', 'GP', 'AX'];
  var sortedImages = {};
  sortOrder.forEach(key => {
    if (imageList[key] !== undefined) {
      sortedImages[key] = imageList[key];
    }
  });
  for (var _key in imageList) {
    if (sortedImages[_key] === undefined) {
      sortedImages[_key] = imageList[_key];
    }
  }
  return sortedImages;
}
export function applyDefaultPaymentRestrictions(paymentOptions, PaymentType, query, isSecureBookingFeatureEnabled) {
  var _paymentOptions$payme;
  if (!!isSecureBookingFeatureEnabled && !!paymentOptions && !!(paymentOptions !== null && paymentOptions !== void 0 && paymentOptions.paymentOptions) && !!(paymentOptions !== null && paymentOptions !== void 0 && (_paymentOptions$payme = paymentOptions.paymentOptions) !== null && _paymentOptions$payme !== void 0 && _paymentOptions$payme.length) && !!(query !== null && query !== void 0 && query.reservationId) && !!query['secure-booking'] && query['secure-booking'] === 'true') {
    paymentOptions.paymentOptions = paymentOptions.paymentOptions.filter(option => option.type !== PaymentType.RESERVE_WITHOUT_CARD);
    return paymentOptions;
  }
}
export function isSecureBookingPage(query, isFeatureEnabled) {
  return !!isFeatureEnabled && !!(query !== null && query !== void 0 && query.reservationId) && !!query['secure-booking'] && query['secure-booking'] === 'true';
}
export function getBookingConfirmationMessage(t, query, isFeatureEnabled) {
  var isSecureBooking = isSecureBookingPage(query, isFeatureEnabled);
  return isSecureBooking ? "".concat(t('nonguaranteed.booking.bookingSecure'), ",") : t('booking.confirmation.thankyouForBookingWithoutCustomerName');
}
export function shouldDisplaySecureBooking(data, hotelBrand, isFeatureFlagEnabled) {
  var arrivalDate = data.arrivalDate,
    area = data.area,
    paymentOption = data.paymentOption,
    bookingStatus = data.bookingStatus;
  if (!isFeatureFlagEnabled || ![Area.PI, Area.BB].includes(area) || bookingStatus === BASKET_STATUS.CANCELLED || !validateArrivalDate(arrivalDate, hotelBrand)) {
    return false;
  }
  switch (paymentOption) {
    case paymentOptions.RESERVE_WITHOUT_CARD:
      return true;
    case paymentOptions.PAY_ON_ARRIVAL:
    case paymentOptions.PAY_NOW:
      return !!(bookingStatus === BASKET_STATUS.PAY_PENDING || bookingStatus === BASKET_STATUS.SECURE_FAILED);
    default:
      return false;
  }
}
export function getHotelBrand(data) {
  var _data$dehydratedState;
  var queries = (data === null || data === void 0 || (_data$dehydratedState = data.dehydratedState) === null || _data$dehydratedState === void 0 ? void 0 : _data$dehydratedState.queries) || [];
  for (var query of queries) {
    var _query$state;
    var brand = query === null || query === void 0 || (_query$state = query.state) === null || _query$state === void 0 || (_query$state = _query$state.data) === null || _query$state === void 0 || (_query$state = _query$state.hotelInformation) === null || _query$state === void 0 ? void 0 : _query$state.brand;
    if (brand) {
      return brand;
    }
  }
  return null;
}
export function getBasketStatus(data) {
  var _data$dehydratedState2;
  var queries = (data === null || data === void 0 || (_data$dehydratedState2 = data.dehydratedState) === null || _data$dehydratedState2 === void 0 ? void 0 : _data$dehydratedState2.queries) || [];
  for (var query of queries) {
    var _query$state2;
    var basket = query === null || query === void 0 || (_query$state2 = query.state) === null || _query$state2 === void 0 || (_query$state2 = _query$state2.data) === null || _query$state2 === void 0 ? void 0 : _query$state2.basket;
    if (basket) {
      return basket;
    }
  }
  return null;
}
export function isValidSecureBooking(_x, _x2, _x3) {
  return _isValidSecureBooking.apply(this, arguments);
}
function _isValidSecureBooking() {
  _isValidSecureBooking = _asyncToGenerator(function* (featureToggles, loadedData, area) {
    var _loadedData$pcksQuery, _loadedData$pcksQuery2, _loadedData$pcksQuery3, _loadedData$pcksQuery4;
    var isSecureBookingFeatureEnabled = featureToggles[FT_PI_BB_NON_GUARANTEED_REMINDER];
    var hotelBrand = getHotelBrand(loadedData);
    var basket = getBasketStatus(loadedData);
    var paymentOption = basket === null || basket === void 0 ? void 0 : basket.paymentOption;
    var basketStatus = basket === null || basket === void 0 ? void 0 : basket.status;
    var secureBookingData = {
      basketReference: loadedData === null || loadedData === void 0 || (_loadedData$pcksQuery = loadedData.pcksQueryInput) === null || _loadedData$pcksQuery === void 0 ? void 0 : _loadedData$pcksQuery.basketReferenceId,
      arrivalDate: (_loadedData$pcksQuery2 = loadedData.pcksQueryInput) === null || _loadedData$pcksQuery2 === void 0 ? void 0 : _loadedData$pcksQuery2.startDate,
      area,
      paymentOption,
      bookingStatus: basketStatus,
      hotelInfo: {
        hotelId: loadedData === null || loadedData === void 0 || (_loadedData$pcksQuery3 = loadedData.pcksQueryInput) === null || _loadedData$pcksQuery3 === void 0 ? void 0 : _loadedData$pcksQuery3.hotelId,
        bookingFlowId: loadedData === null || loadedData === void 0 || (_loadedData$pcksQuery4 = loadedData.pcksQueryInput) === null || _loadedData$pcksQuery4 === void 0 ? void 0 : _loadedData$pcksQuery4.bookingFlowId
      }
    };
    var isBookingValid = shouldDisplaySecureBooking(secureBookingData, hotelBrand, isSecureBookingFeatureEnabled);
    return {
      error: !isBookingValid
    };
  });
  return _isValidSecureBooking.apply(this, arguments);
}